import { signalStore, withState } from '@ngrx/signals';
import { CustomGridStackWidget } from '../../services/grid-widget-config.service';
import { EntityId, EntityState, withEntities } from '@ngrx/signals/entities';

import { withWidgetMethods } from './widget.widget-methods';
import { withChartMethods } from './widget.chart-methods';
import { withWidgetCoreFeatures } from './widget.core-features';
import { withGridMethods } from './widget.grid-methods';

export interface WidgetState extends EntityState<CustomGridStackWidget> {
  selectedId: null | string;
  selection: CustomGridStackWidget[];
  activeConfig: boolean | number;
  prevConfig: CustomGridStackWidget | null;
  rerenderId: EntityId;
  poiFastSwitch: boolean;
  rerenderIds: EntityId[];
  event: string;
  eventOptions: any;
  widgetToExport: null | string;
}

export const initialWidgetState: WidgetState = {
  ids: [],
  entityMap: {},
  selectedId: null,
  selection: [],
  activeConfig: false,
  poiFastSwitch: false,
  prevConfig: null,
  rerenderId: '',
  rerenderIds: [],
  event: '',
  eventOptions: undefined,
  widgetToExport: null,
};

export const WidgetStore = signalStore(
  { providedIn: 'root' },
  withEntities<CustomGridStackWidget>(),
  withState(initialWidgetState),
  withWidgetCoreFeatures(),
  withGridMethods(),
  withWidgetMethods(),
  withChartMethods()
);
